<template>
    <div class="cc-recap" :class="{'cc-recap--with-contact': contact.display}">
        <div class="cc-recap__header">
            <div class="cc-title cc-title--section">{{ translations['Cart contents'] }}</div>
        </div>
        <div class="cc-recap__main">
            <products/>
            <div v-if="config.theme_settings.discount_block_position === 'after_products_list'">
              <vouchers/>
            </div>
            <selected-carrier/>
            <selected-payment/>
            <div class="cc-total-price-tax-excluded" v-if="config.theme_settings.total_price_excluded_position === 'before_carrier_price'">
              <div class="cc-total-price-tax-excluded__label">{{ translations['Total price tax excluded'] }}</div>
              <div class="cc-total-price-tax-excluded__price">{{ summary.formattedPrices.total_price_tax_excluded }}</div>
            </div>
            <div class="cc-total-price-tax-excluded" v-if="config.theme_settings.total_tax_position === 'before_carrier_price'">
              <div class="cc-total-price-tax-excluded__label">{{ translations['Total tax'] }}</div>
              <div class="cc-total-price-tax-excluded__price">{{ this.summary.formattedPrices.totalTax }}</div>
            </div>
            <div v-if="config.theme_settings.discount_block_position === 'before_prices_block'">
              <vouchers/>
            </div>
            <prices/>
            <free-delivery/>
            <iqit-free-delivery-count/>
            <custom-message/>
            <note v-if="config.order_note_active"/>
            <consents/>
        </div>
        <div class="cc-recap__footer">
            <div class="minimal-purchase-error text-danger" v-if="minimalPurchase">{{ minimalPurchase }}</div>
            <button class="cc-button cc-button--order" :disabled="minimalPurchase !== ''" @click="$emit('finishOrder')">{{ translations['Finish order'] }}</button>
        </div>
      <div class="cc-recap__order-info" v-if="orderInfo" v-html="orderInfo"></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    import Products from "./Products";
    import SelectedCarrier from "./SelectedCarrier";
    import SelectedPayment from "./SelectedPayment";
    import Vouchers from "./Vouchers";
    import Prices from "./Prices";
    import FreeDelivery from "./FreeDelivery";
    import Consents from "./Consents";
    import Note from "./Note";
    import CustomMessage from "./CustomMessage";
    import IqitFreeDeliveryCount from "../_common/modules/iqitfreedeliverycount/IqitFreeDeliveryCount";

    export default {
        components: {
            IqitFreeDeliveryCount,
            CustomMessage,
            Products,
            SelectedCarrier,
            SelectedPayment,
            Vouchers,
            Prices,
            FreeDelivery,
            Consents,
            Note,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                config: state => state.config,
                contact: state => state.contact,
                summary: state => state.summary,
                currentCarrier: state => state.currentCarrier,
                currentPayment: state => state.currentPayment,
                orderInfo: state => state.config.order_info,
                minimalPurchase: state => state.config.minimal_purchase_required,
            }),
            totalTax: function () {
              let carrierTax = 0;
              if (this.currentCarrier) {
                carrierTax = parseFloat(this.currentCarrier.price - this.currentCarrier.priceTaxExcl);
              }
              let paymentTax = 0;
              if (this.currentPayment) {
                paymentTax = parseFloat(this.currentPayment.price - this.currentPayment.priceTaxExcl);
              }
              let totalProductsTax = parseFloat(this.summary.total_products_tax);
              return totalProductsTax
                  + carrierTax
                  + paymentTax;
            }
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/recap";
    .minimal-purchase-error {
      color: #dc3545;
      text-align: center;
      font-size: 0.875rem;
      font-weight: bold;
      border: 2px solid #dc3545;
      padding: 8px 8px;
      margin-bottom: 8px;
    }
</style>
